<template>
  <section class="settings-card danger-card">
    <div class="danger-header">
      <i class="el-icon-warning-outline danger-icon"></i>
      <div>
        <h2 class="card-title danger">危险操作</h2>
        <p class="danger-desc">删除项目后，该项目下所有的任务、数据、成员权限以及相关文件将被永久移除，无法恢复。请谨慎操作。</p>
      </div>
    </div>
    <el-button type="danger" size="small" @click="handleDelete" class="delete-btn">删除项目</el-button>
  </section>
</template>

<script>
import { deleteProject } from 'index/api/project/manager'

export default {
  name: 'DangerZone',
  props: {
    projectId: { type: [String, Number], required: true }
  },
  methods: {
    handleDelete() {
      this.$confirm('确定删除该项目吗？删除后项目下所有数据将被永久移除，无法恢复。', '警告', {
        type: 'warning', confirmButtonText: '确定删除',
        confirmButtonClass: 'el-button--danger', customClass: 'settings-confirm-dialog'
      }).then(async () => {
        try {
          await deleteProject(this.projectId)
          this.$message.success('项目已删除')
          this.$router.push('/project')
        } catch (e) { this.$message.error(e?.data?.message || e?.message || '删除失败') }
      }).catch(() => {})
    }
  }
}
</script>
